import { render } from "./SessionTimeoutWarning.vue?vue&type=template&id=84a9f20c"
import script from "./SessionTimeoutWarning.vue?vue&type=script&lang=js"
export * from "./SessionTimeoutWarning.vue?vue&type=script&lang=js"

import "./SessionTimeoutWarning.vue?vue&type=style&index=0&id=84a9f20c&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/auth/SessionTimeoutWarning.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "84a9f20c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('84a9f20c', __exports__)) {
    console.log('reload')
    api.reload('84a9f20c', __exports__)
  }
  
  module.hot.accept("./SessionTimeoutWarning.vue?vue&type=template&id=84a9f20c", () => {
    console.log('re-render')
    api.rerender('84a9f20c', render)
  })

}


export default __exports__